import { Dispatch } from 'react-redux';
import { AuthActionCreators, IApplicationState } from "../";
import { IBaseResponse, IReconciliation } from '@nkr/models/index';
import { IRequiredField } from '@nkr/views/donors/reconciliation/models';

export interface IDashSelfServeReconciliationUploadResponse {
    data: {
        success: boolean,
        results: {
            headers: string[],
            sampleRow: string[],
            requiredFields: IRequiredField[],
            fileName: string
        }
    }
}

export interface IDashSelfServeReconciliationProcessResponse {
    data: {
        success: boolean,
        results: IReconciliation
    }
}

export interface IDashSelfServeReconciliationCreateResponse {
    data: {
        success: boolean,
        results: number
    }
}

export const ActionCreators = {
    uploadDashSelfServeReconciliationFile: (centerId: number, hasColumnHeaders: boolean, file: File) => async (dispatch: Dispatch<IApplicationState>): Promise<IDashSelfServeReconciliationUploadResponse> => {
        let formData = new FormData();
        formData.append('centerId', centerId.toString());
        formData.append('hasColumnHeaders', hasColumnHeaders.toString());
        formData.append('file', file);

        let options = {
            url: `${__API__}/donor-intake/reconciliation/upload`,
            data: formData
        };

        try {
            return await dispatch(AuthActionCreators.apiPostFormData(options));
        } catch (error) {
            throw error;
        }
    },
    processDashSelfServeReconciliationFile: (centerId: number, hasColumnHeaders: boolean, mappedFields: string[], fileName: string) => async (dispatch: Dispatch<IApplicationState>): Promise<IDashSelfServeReconciliationProcessResponse> => {
        let options = {
            url: `${__API__}/donor-intake/reconciliation/process`,
            data: {
                centerId,
                hasColumnHeaders,
                mappedFields,
                fileName
            }
        };

        try {
            return await dispatch(AuthActionCreators.apiPost(options));
        } catch (error) {
            throw error;
        }
    },
    updateSelfServeReconciliationEntry: (id: number, firstName: string, lastName: string, birthDate: string, donationType: number, transplantDate: string) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let options = {
            url: `${__API__}/donor-intake/reconciliation/update`,
            data: {
                id,
                firstName,
                lastName,
                birthDate,
                donationType,
                transplantDate
            }
        };

        try {
            return await dispatch(AuthActionCreators.apiPost(options));
        } catch (error) {
            throw error;
        }
    },
    createSelfServeReconciliationEntry: (
        centerId: number,
        firstName: string,
        lastName: string,
        birthDate: string,
        donationType: number,
        transplantDate: string
    ) => async (dispatch: Dispatch<IApplicationState>): Promise<IDashSelfServeReconciliationCreateResponse> => {
        let options = {
            url: `${__API__}/donor-intake/reconciliation/create`,
            data: {
                centerId,
                firstName,
                lastName,
                birthDate,
                donationType,
                transplantDate
            }
        };

        try {
            return await dispatch(AuthActionCreators.apiPost(options));
        } catch (error) {
            throw error;
        }
    },
}